import TwilioIcon from "./twilio.svg";
import VrAssistantIcon from "./vr_assistant.svg";
import StripeIcon from "./stripe.svg";

/** Official PayPal logo (SVG) from paypalobjects.com - scales sharply at icon size; used in integrations for parity and brand compliance */
export const PAYPAL_LOGO_INTEGRATION_URL = "https://www.paypalobjects.com/webstatic/i/logo/rebrand/ppcom.svg";

/**
 * Map of app icons
 * Add new icons here as you add more apps
 */
export const APP_ICONS = {
  paypal: PAYPAL_LOGO_INTEGRATION_URL,
  twilio: TwilioIcon,
  stripe: StripeIcon,
  vr_assistant: VrAssistantIcon,
} as const;

export type AppIconKey = keyof typeof APP_ICONS;

export { TwilioIcon };
